import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


export const getScroll = (id) => {
    document.getElementById(id).scrollIntoView();
}





